module.exports = __webpack_public_path__ + "static/img/wifiDevice.56149848.png";